import { useRestClient } from '@/contexts/QueryProvider'

export function useGetFaqMarkdown(appId?: number) {
  const { getMarkdownApiGetFaq } = useRestClient()
  return getMarkdownApiGetFaq.useSuspenseQuery({ path: { applicationId: appId! } })
}

export function useSaveFaqMarkdown(appId?: number) {
  const { postMarkdownApiSaveFaq } = useRestClient()
  return postMarkdownApiSaveFaq.useMutation({ path: { applicationId: appId! } })
}
